// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__zjU14","range":"Form_range__2VvL3","types_list":"Form_types_list__20T4G","submit_button":"Form_submit_button__1WrU4"};